import { httpUtil } from './httpUtil';

const querystring = require('querystring');


export const paygateservices = {
    getPaymentInfo,
    getTopupInfo,
};

async function getPaymentInfo({
    pay_request_id,
    checksum,
    url,
    apikey
} = {}) {
    try {
        const response = await get({
            resourcePath: url,
            queryParams: {
                pay_request_id,
                checksum
            },
            apikey:apikey
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

async function getTopupInfo({
    body,
    url,
    apikey,
}) {
    try {
        const response = await post({
            resourcePath: url,
            body: body,
            apikey: apikey
        })
        return response;
    } catch (ex) {
        return ex;
    }
}

//#region helpers
function createOption() {
    var options = {};
    options.headers = {
        'User-Agent': 'request',
        'Content-Type': 'application/json; charset=utf-8'
    };
    return options;
}

function cleanObj(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
}

function json2Obj(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}

function getURI(resourcePath) {
    return document.p + resourcePath;
}

async function get({
    resourcePath,
    queryParams,
    apikey
}) {
    try {
        var options = createOption();
        options.method = 'GET';
        let uri = resourcePath;
        options.headers['api_key'] = apikey;
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));;
        console.log("GET uri:", uri);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("AAAA e:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function post({
    resourcePath,
    body,
    apikey,
}) {
    try {
        var options = createOption();
        options.method = 'POST';
        let uri = resourcePath;
        options.headers['api_key'] = apikey;
        if (body)
            options.body = JSON.stringify(body);
        console.log("GET uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("post exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}
//#endregion
